import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Twitter, Linkedin, Facebook, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-au-navy text-gray-300 pt-16 pb-8" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-115">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-116">
          {/* Brand & About */}
          <div className="col-span-1 lg:col-span-1" data-id="element-117">
            <div className="flex items-center space-x-3 mb-6" data-id="element-118">
              <div className="w-10 h-10 relative flex-shrink-0" data-id="element-119">
                <svg viewBox="0 0 100 100" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-120">
                  <circle cx="50" cy="50" r="48" stroke="#f4c430" strokeWidth="2" fill="none" data-id="element-121" />
                  <path d="M35 30C45 20 60 20 70 30C80 40 80 55 70 65C60 75 45 75 35 65C25 55 25 40 35 30Z" fill="#f4c430" opacity="0.5" data-id="element-122" />
                  <path d="M40 35C48 28 58 28 65 35C72 42 72 52 65 58C58 65 48 65 40 58C32 52 32 42 40 35Z" fill="#15703c" data-id="element-123" />
                </svg>
              </div>
              <div className="flex flex-col" data-id="element-124">
                <span className="text-white font-serif font-bold text-lg leading-tight" data-id="element-125">
                  African Union
                </span>
                <span className="text-gray-400 text-xs font-medium leading-tight" data-id="element-126">
                  Commission
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed" data-id="element-127">
              Advancing Africa's global partnerships for sustainable development
              and driving transformative projects across the continent.
            </p>
            <div className="flex space-x-4" data-id="element-128">
              <a href="#" className="text-gray-400 hover:text-au-gold transition-colors" data-id="element-129">
                <Twitter size={20} data-id="element-130" />
              </a>
              <a href="#" className="text-gray-400 hover:text-au-gold transition-colors" data-id="element-131">
                <Linkedin size={20} data-id="element-132" />
              </a>
              <a href="#" className="text-gray-400 hover:text-au-gold transition-colors" data-id="element-133">
                <Facebook size={20} data-id="element-134" />
              </a>
              <a href="#" className="text-gray-400 hover:text-au-gold transition-colors" data-id="element-135">
                <Youtube size={20} data-id="element-136" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-137">
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider" data-id="element-138">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-139">
              <li data-id="element-140">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-141">
                  About the AU
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-143">
                  Member States
                </a>
              </li>
              <li data-id="element-144">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-145">
                  Agenda 2063
                </a>
              </li>
              <li data-id="element-146">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-147">
                  Press & Media
                </a>
              </li>
              <li data-id="element-148">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-149">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Procurement */}
          <div data-id="element-150">
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider" data-id="element-151">
              Procurement
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-152">
              <li data-id="element-153">
                <Link to="/bids" className="hover:text-au-gold transition-colors" data-id="element-154">
                  Current Bids & Tenders
                </Link>
              </li>
              <li data-id="element-155">
                <Link to="/procurement" className="hover:text-au-gold transition-colors" data-id="element-156">
                  Vendor Registration
                </Link>
              </li>
              <li data-id="element-157">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-158">
                  Procurement Manual
                </a>
              </li>
              <li data-id="element-159">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-160">
                  Awarded Contracts
                </a>
              </li>
              <li data-id="element-161">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-162">
                  Fraud & Corruption Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-163">
            <h4 className="text-white font-bold mb-6 uppercase text-sm tracking-wider" data-id="element-164">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm" data-id="element-165">
              <li className="flex items-start" data-id="element-166">
                <MapPin size={18} className="mr-3 text-au-gold flex-shrink-0 mt-0.5" data-id="element-167" />
                <span data-id="element-168">
                  African Union Headquarters
                  <br data-id="element-169" />
                  P.O. Box 3243, Roosvelt Street
                  <br data-id="element-170" />
                  W21K19, Addis Ababa, Ethiopia
                </span>
              </li>
              <li className="flex items-center" data-id="element-171">
                <Phone size={18} className="mr-3 text-au-gold flex-shrink-0" data-id="element-172" />
                <span data-id="element-173">447916961113</span>
              </li>
              <li className="flex items-center" data-id="element-174">
                <Mail size={18} className="mr-3 text-au-gold flex-shrink-0" data-id="element-175" />
                <a href="mailto:info@aucommissions.org" className="hover:text-au-gold transition-colors" data-id="element-176">
                  info@aucommissions.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-177">
          <p data-id="element-178">
            &copy; {new Date().getFullYear()} African Union Commission. All
            rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-179">
            <a href="#" className="hover:text-white transition-colors" data-id="element-180">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-181">
              Terms of Use
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-182">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}